import { ConfigContext } from "context/ConfigContext";
import { useContext } from "react";
import ReactLoading from "react-loading";
import Lottie from "react-lottie";
import Loader from "../../../assets/lottie/loader.json";
import gs from "../../../styles/styles";
import BaseLayout from "../BaseLayout";

type LoadingScreenProps = {
  headerVisible?: boolean;
  mudrexLoader?: boolean;
};

const LoadingScreen = ({
  headerVisible = true,
  mudrexLoader = false,
}: LoadingScreenProps) => {
  return (
    <BaseLayout
      headerVisible={headerVisible}
      brandingVisible={false}
      body={<LoadingView mudrexLoader={mudrexLoader} />}
      footer={null}
      bottomSheet={null}
    />
  );
};

export const MudrexLoader = () => {
  const options = {
    loop: true,
    autoplay: true,
    animationData: Loader,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return <Lottie options={options} height={70} width={70} />;
};

type LoadingViewProps = {
  mudrexLoader?: boolean;
};

export const LoadingView = ({ mudrexLoader }: LoadingViewProps) => {
  const configContext = useContext(ConfigContext);
  const globalStyles = gs();
  const theme = configContext?.config?.theme;
  const primaryColor = theme?.palette?.primary?.main || "#000000";

  return (
    <div className={globalStyles.containerCenter}>
      {mudrexLoader ? (
        <MudrexLoader />
      ) : (
        <ReactLoading type={"bars"} color={primaryColor} />
      )}
    </div>
  );
};

export default LoadingScreen;
